import { render } from "./PropertyCommunity.vue?vue&type=template&id=161e4398"
import script from "./PropertyCommunity.vue?vue&type=script&lang=js"
export * from "./PropertyCommunity.vue?vue&type=script&lang=js"

import "./PropertyCommunity.vue?vue&type=style&index=0&id=161e4398&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__